import React from 'react';

const InfoPanel = () => (
    <section aria-label="About the Direct Project">
        <div className="ses-infopanel animate slide delay-7">
            <div className="container">
                <article className="ses-infoblock-container" aria-labelledby="infoPanelBlock1">
                    <div className="ses-doc-header" aria-hidden="true"></div>
                    <p className="ses-infoblock" id="infoPanelBlock1">The Direct Project is a federal initiative for standards-based healthcare communications, with the goal of enabling communications between all healthcare providers and patients.</p>
                </article>
                <article className="ses-infoblock-container" aria-labelledby="infoPanelBlock2">
                    <div className="ses-mail-header"></div>
                    <p className="ses-infoblock" id="infoPanelBlock2">Direct secure messaging empowers you to communicate with any physician or patient with a Direct email address in a way that is HIPAA and HITECH compliant. </p>
                </article>
                <article className="ses-infoblock-container" aria-labelledby="infoPanelBlock3">
                    <div className="ses-patient-header" aria-hidden="true"></div>
                    <p className="ses-infoblock" id="infoPanelBlock3">The ability to send transition of care documents (CCDs) using Direct secure messaging. This can help you meet Meaningful Use attestation requirements and engage your patients. </p>
                </article>
            </div>
        </div>
    </section>
);

export default InfoPanel;
